import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { WarrantyProcessAdapter } from './adapters/warranty-process.adapter';
import { OccWarrantyProcessAdapter } from './adapters/impl/occ-warranty-process.adapter';



@NgModule({ imports: [CommonModule], providers: [
        {
            provide: WarrantyProcessAdapter,
            useClass: OccWarrantyProcessAdapter,
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class OccModule { }
